import React from 'react';
import { FadeIn, CTAButton, Section } from './Shared';
import { useCountdown } from '../hooks/useCountdown';
import { ShieldCheck, Lock, CreditCard, CheckCircle2, Star, Users, BookOpen, Gift, XCircle } from 'lucide-react';
export const UrgencyBar = () => {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  return <div className="bg-navy text-white py-2 md:py-3 px-3 md:px-4 sticky top-0 z-50 shadow-md" data-id="element-254">
      <div className="max-w-4xl mx-auto flex flex-row items-center justify-center gap-1.5 md:gap-6 text-center text-[11px] md:text-base font-medium" data-id="element-255">
        <div className="flex items-center gap-1 md:gap-2" data-id="element-256">
          <span className="animate-pulse hidden md:inline" data-id="element-257">⏰</span>
          <span className="hidden md:inline" data-id="element-258">
            PRECIO DE LANZAMIENTO — CIERRA EN:
          </span>
          <span className="md:hidden" data-id="element-259">LANZAMIENTO —</span>
          <span className="font-bold bg-white/20 px-1.5 md:px-2 py-0.5 md:py-1 rounded text-xs md:text-base" data-id="element-260">
            {hours.toString().padStart(2, '0')}:
            {minutes.toString().padStart(2, '0')}:
            {seconds.toString().padStart(2, '0')}
          </span>
        </div>
        <span className="text-brandOrange font-bold text-[10px] md:text-base" data-id="element-261">
          Sube $15.000. No vuelve.
        </span>
      </div>
    </div>;
};
export const Hero = () => {
  return <Section className="bg-white pt-8 md:pt-16 pb-16" data-id="element-262">
      <div className="max-w-4xl mx-auto text-center space-y-8" data-id="element-263">
        <FadeIn data-id="element-264">
          <div className="space-y-6" data-id="element-265">
            <div className="inline-block bg-navy/10 text-navy font-bold px-4 py-1.5 rounded-full text-sm mb-2" data-id="element-266">
              EL ARSENAL DEL PROFE™
            </div>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-navy leading-tight" data-id="element-267">
              Todo tu año de Educación Física.
              <br data-id="element-268" />
              <span className="text-brandOrange" data-id="element-269">Listo. Desde hoy.</span>
            </h1>
          </div>
        </FadeIn>

        <FadeIn delay={0.15} data-id="element-270">
          <a href="#pricing" className="block cursor-pointer" data-id="element-271">
            <img src="https://cdn.magicpatterns.com/uploads/av2ieCVVkhxvJcz5fiCSA2/ChatGPT_Image_31_mar_2026,_13_28_46_-_Editado.png" alt="El Arsenal del Profe Mockup" className="w-full max-w-2xl mx-auto h-auto object-contain hover:scale-[1.02] transition-transform duration-300" data-id="element-272" />
          </a>
          <p className="text-xl md:text-2xl font-bold text-brandOrange mt-6" data-id="element-273">
            Sistema Completo de Clases Listas Para Usar
          </p>
          <p className="text-gray-500 mt-2" data-id="element-274">
            El sistema N°1 para profes de Educación Física en Argentina —
            Primaria + Secundaria — Todos los niveles
          </p>
        </FadeIn>

        <FadeIn delay={0.25} data-id="element-275">
          <div className="max-w-2xl mx-auto space-y-6" data-id="element-276">
            <div className="bg-gray-50 p-6 rounded-2xl border border-gray-100 space-y-4 text-left" data-id="element-277">
              <p className="font-semibold text-navy text-center" data-id="element-278">
                Juegos + Actividades + Clases Completas listos para usar. Sin
                buscar. Sin armar. Sin perder el domingo.
              </p>
              <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm text-gray-700" data-id="element-279">
                <li className="flex items-center gap-2" data-id="element-280">
                  <span className="text-xl" data-id="element-281">📄</span> 100% PDF
                </li>
                <li className="flex items-center gap-2" data-id="element-282">
                  <span className="text-xl" data-id="element-283">⚡</span> Acceso en 5 minutos
                </li>
                <li className="flex items-center gap-2" data-id="element-284">
                  <span className="text-xl" data-id="element-285">🇦🇷</span> Primaria + Secundaria
                </li>
                <li className="flex items-center gap-2" data-id="element-286">
                  <span className="text-xl" data-id="element-287">🎯</span> Sin materiales + Con
                  materiales
                </li>
                <li className="flex items-center gap-2 sm:col-span-2 justify-center" data-id="element-288">
                  <span className="text-xl" data-id="element-289">📚</span> 120+ actividades listas
                </li>
              </ul>
            </div>

            <div className="space-y-4 pt-2" data-id="element-290">
              <CTAButton href="#pricing" fullWidth className="text-xl py-5" data-id="element-291">
                QUIERO EL MEGAPACK AHORA →
              </CTAButton>

              <div className="flex flex-wrap items-center justify-center gap-4 text-xs text-gray-500 font-medium" data-id="element-292">
                <span className="flex items-center gap-1" data-id="element-293">
                  <ShieldCheck size={16} className="text-green-600" data-id="element-294" /> Garantía
                  30 días
                </span>
                <span className="flex items-center gap-1" data-id="element-295">
                  <Lock size={16} className="text-gray-600" data-id="element-296" /> Pago seguro
                </span>
                <span className="flex items-center gap-1" data-id="element-297">
                  <CreditCard size={16} className="text-blue-600" data-id="element-298" /> Mercado
                  Pago | Tarjeta | Transferencia
                </span>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </Section>;
};
export const SocialProof = () => {
  return <div className="bg-gray-50 border-y border-gray-100 py-10" data-id="element-299">
      <div className="max-w-6xl mx-auto px-4" data-id="element-300">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center divide-x divide-gray-200" data-id="element-301">
          <FadeIn delay={0.1} data-id="element-302">
            <div className="text-3xl md:text-4xl font-bold text-navy mb-1" data-id="element-303">
              +100
            </div>
            <div className="text-sm text-gray-600 font-medium" data-id="element-304">
              profes confían
            </div>
          </FadeIn>
          <FadeIn delay={0.2} data-id="element-305">
            <div className="text-3xl md:text-4xl font-bold text-navy mb-1" data-id="element-306">
              6
            </div>
            <div className="text-sm text-gray-600 font-medium" data-id="element-307">
              Tomos listos
            </div>
          </FadeIn>
          <FadeIn delay={0.3} data-id="element-308">
            <div className="text-3xl md:text-4xl font-bold text-navy mb-1" data-id="element-309">
              6
            </div>
            <div className="text-sm text-gray-600 font-medium" data-id="element-310">
              Bonos incluidos
            </div>
          </FadeIn>
          <FadeIn delay={0.4} data-id="element-311">
            <div className="text-3xl md:text-4xl font-bold text-navy mb-1" data-id="element-312">
              4.9/5
            </div>
            <div className="text-sm text-gray-600 font-medium flex items-center justify-center gap-1" data-id="element-313">
              calificación{' '}
              <Star size={14} className="fill-yellow-400 text-yellow-400" data-id="element-314" />
            </div>
          </FadeIn>
        </div>
      </div>
    </div>;
};
export const Testimonials1 = () => {
  const testimonials = [{
    initials: 'MR',
    text: 'Llegué al lunes con todo listo por primera vez en años. Los juegos sin materiales me salvaron cuando el depósito estaba cerrado. No lo puedo creer.',
    author: 'Marcelo R., Buenos Aires',
    role: 'Profe de Ed. Física'
  }, {
    initials: 'CP',
    text: 'Tengo grupos de 40 chicos y espacio mínimo. El bono de Espacios Chicos resolvió algo que no sabía cómo resolver hace 3 años.',
    author: 'Carolina P., Córdoba',
    role: 'Escuela Primaria'
  }, {
    initials: 'DG',
    text: 'El domingo a la noche ya no me angustia. Abro el Tomo 6 y en 10 minutos tengo la clase del lunes armada de punta a punta.',
    author: 'Diego G., Rosario',
    role: 'Secundaria Técnica'
  }];
  return <Section className="bg-white" data-id="element-315">
      <div className="grid md:grid-cols-3 gap-6" data-id="element-316">
        {testimonials.map((t, i) => <FadeIn key={i} delay={i * 0.1} data-id="element-317">
            <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100 h-full flex flex-col" data-id="element-318">
              <div className="flex items-center gap-4 mb-4" data-id="element-319">
                <div className="w-12 h-12 bg-navy text-white rounded-full flex items-center justify-center font-bold text-lg" data-id="element-320">
                  {t.initials}
                </div>
                <div className="flex text-yellow-400" data-id="element-321">
                  {[...Array(5)].map((_, j) => <Star key={j} size={16} className="fill-current" data-id="element-322" />)}
                </div>
              </div>
              <p className="text-gray-700 italic mb-6 flex-grow" data-id="element-323">"{t.text}"</p>
              <div data-id="element-324">
                <p className="font-bold text-navy" data-id="element-325">{t.author}</p>
                <p className="text-sm text-gray-500" data-id="element-326">{t.role}</p>
              </div>
            </div>
          </FadeIn>)}
      </div>
    </Section>;
};
export const Problem = () => {
  const painPoints = ['Domingo buscando juegos en YouTube e Instagram que nunca quedan bien para tu grupo', 'Clases armadas la noche anterior, a las corridas, con lo que encontrás', 'Siempre los mismos juegos porque no tenés un banco de actividades serio', 'El día de lluvia sin plan B y el grupo se te va de las manos', 'Grupos grandes con poco espacio y sin saber qué hacer con eso', 'Fin de semana agotado y el domingo a la noche volvés a empezar el mismo ciclo'];
  return <Section className="bg-navy text-white" data-id="element-327">
      <div className="max-w-3xl mx-auto" data-id="element-328">
        <FadeIn data-id="element-329">
          <h2 className="text-3xl md:text-5xl font-bold mb-8 text-center text-brandOrange" data-id="element-330">
            ¿Cuántos domingos más vas a perder así?
          </h2>

          <div className="space-y-4 text-lg text-gray-200 mb-12" data-id="element-331">
            <p data-id="element-332">Sos profe de Educación Física.</p>
            <p data-id="element-333">
              Elegiste esta profesión porque amás el movimiento, el deporte y
              ver a tus alumnos crecer.
            </p>
            <p data-id="element-334">
              Pero nadie te dijo que ibas a pasar los domingos buscando juegos
              que no encajan con tu grupo, armando clases a último momento y
              llegando al lunes con algo que "más o menos sirve".
            </p>
            <p className="font-bold text-white text-xl pt-4" data-id="element-335">
              No es falta de vocación.
              <br data-id="element-336" />
              Es falta de un sistema.
            </p>
          </div>

          <div className="bg-white/5 border border-white/10 rounded-2xl p-6 md:p-8 space-y-4 mb-10" data-id="element-337">
            {painPoints.map((point, i) => <div key={i} className="flex items-start gap-3" data-id="element-338">
                <XCircle className="text-red-400 shrink-0 mt-1" size={24} data-id="element-339" />
                <p className="text-gray-300" data-id="element-340">{point}</p>
              </div>)}
          </div>

          <p className="text-2xl md:text-3xl font-bold text-center text-white" data-id="element-341">
            ¿Y si este fuera el último domingo que pasás así?
          </p>
        </FadeIn>
      </div>
    </Section>;
};